/* eslint-disable react-refresh/only-export-components */

import { ReactNode } from 'react';
import { Tab } from '@root/globalTypes';

const NAV_ICON_SIZE = 45;

export const HotSeat = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}
    viewBox="0 0 45 45">
    <path
      d="M12.2 24.8c0 1.3.3 2.6.8 3.8a9.4 9.4 0 0 0 2.4 3.1V31c0-.8.2-1.5.5-2.3.3-.7.8-1.3 1.4-2l4.5-4.2 4.5 4.3c.6.6 1.1 1.2 1.4 2 .3.7.5 1.4.5 2.2v.7c1-.9 1.8-2 2.4-3.1.5-1.2.8-2.5.8-3.8a9 9 0 0 0-2.9-6.7 6.5 6.5 0 0 1-3.5 1 6.3 6.3 0 0 1-6.4-5.5 23 23 0 0 0-4.7 5.5 10.4 10.4 0 0 0-1.7 5.8Zm9.6 2L19.5 29a3 3 0 0 0-.7 1l-.2 1c0 .9.3 1.6 1 2.2.6.6 1.3.8 2.2.8.9 0 1.6-.2 2.3-.8a2.8 2.8 0 0 0 .7-3.3l-.7-1-2.3-2Zm0-19V13c0 .8.3 1.6 1 2.1.6.6 1.3 1 2.2 1a3.1 3.1 0 0 0 2.5-1.2l.7-.9a12.1 12.1 0 0 1 6.4 10.8c0 3.4-1.2 6.4-3.7 8.7a12.6 12.6 0 0 1-9.1 3.6c-3.6 0-6.6-1.2-9-3.6A11.7 11.7 0 0 1 9 24.8c0-3.3 1.2-6.4 3.5-9.4s5.4-5.5 9.3-7.5Z"
      fill="currentColor"
    />
  </svg>
);

export const Workload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}
    viewBox="0 0 45 45">
    <path
      d="M11.8 37.1c-.8 0-1.4-.2-2-.8-.5-.5-.8-1.2-.8-2V12.8c0-.8.3-1.4.8-2 .6-.5 1.2-.8 2-.8h2.1V7.9h2.6v2H28V8h2.6v2h2.1c.8 0 1.4.4 2 1 .5.5.8 1.1.8 2v21.4c0 .8-.3 1.5-.8 2-.6.6-1.2.8-2 .8H11.8Zm0-2.8h20.8v-15H11.8v15Zm0-17h20.8v-4.5H11.8v4.4Zm10.4 8.2c-.4 0-.8-.2-1-.5-.4-.3-.5-.6-.5-1 0-.5.1-.9.4-1.2.3-.3.7-.4 1.1-.4.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .5-.1.8-.4 1.1-.3.3-.7.5-1 .5Zm-5.6 0c-.5 0-.8-.2-1.1-.5-.3-.3-.5-.6-.5-1 0-.5.2-.9.5-1.2.3-.3.6-.4 1-.4.5 0 .9.1 1.1.4.3.3.5.7.5 1.1 0 .5-.2.8-.5 1.1-.2.3-.6.5-1 .5Zm11.3 0c-.5 0-.8-.2-1.1-.5-.3-.3-.5-.6-.5-1 0-.5.2-.9.5-1.2.3-.3.6-.4 1-.4.5 0 .8.1 1.1.4.3.3.5.7.5 1.1 0 .5-.2.8-.5 1.1-.3.3-.6.5-1 .5ZM22.2 31c-.4 0-.8-.2-1-.5-.4-.3-.5-.6-.5-1 0-.5.1-.8.4-1.1.3-.3.7-.5 1.1-.5.4 0 .8.2 1 .5.4.3.5.6.5 1 0 .5-.1.8-.4 1.1-.3.3-.7.5-1 .5Zm-5.6 0c-.5 0-.8-.2-1.1-.5-.3-.3-.5-.6-.5-1 0-.5.2-.8.5-1.1.3-.3.6-.5 1-.5.5 0 .9.2 1.1.5.3.3.5.6.5 1 0 .5-.2.8-.5 1.1-.2.3-.6.5-1 .5Zm11.3 0c-.5 0-.8-.2-1.1-.5-.3-.3-.5-.6-.5-1 0-.5.2-.8.5-1.1.3-.3.6-.5 1-.5.5 0 .8.2 1.1.5.3.3.5.6.5 1 0 .5-.2.8-.5 1.1-.3.3-.6.5-1 .5Z"
      fill="currentColor"
    />
  </svg>
);

export const OnDeck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}>
    <path
      d="M13.7 30.8H23v-3.1h-9.3v3Zm4.6-6.2h9.4v-3.2h-9.4v3.2Zm4.7-6.3h9.3v-3H23v3ZM12.1 37a3 3 0 0 1-2.2-1A3 3 0 0 1 9 34V12a3 3 0 0 1 1-2.2A3 3 0 0 1 12 9H34a3 3 0 0 1 2.2 1A3 3 0 0 1 37 12V34a3 3 0 0 1-1 2.2 3 3 0 0 1-2.1.9H12Zm0-3.1H34V12H12V34Z"
      fill="currentColor"
    />
  </svg>
);

export const Map = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}
    viewBox="0 0 45 45">
    <path
      fill="currentColor"
      d="M22.8 23c.88 0 1.633-.313 2.26-.94.627-.627.94-1.38.94-2.26 0-.88-.313-1.633-.94-2.26a3.081 3.081 0 0 0-2.26-.94c-.88 0-1.633.313-2.26.94a3.081 3.081 0 0 0-.94 2.26c0 .88.313 1.633.94 2.26.627.627 1.38.94 2.26.94Zm0 11.76c3.253-2.987 5.667-5.7 7.24-8.14 1.573-2.44 2.36-4.607 2.36-6.5 0-2.907-.927-5.287-2.78-7.14-1.853-1.853-4.127-2.78-6.82-2.78-2.693 0-4.967.927-6.82 2.78-1.853 1.853-2.78 4.233-2.78 7.14 0 1.893.787 4.06 2.36 6.5 1.573 2.44 3.987 5.153 7.24 8.14Zm0 4.24c-4.293-3.653-7.5-7.047-9.62-10.18-2.12-3.133-3.18-6.033-3.18-8.7 0-4 1.287-7.187 3.86-9.56S19.413 7 22.8 7c3.387 0 6.367 1.187 8.94 3.56 2.573 2.373 3.86 5.56 3.86 9.56 0 2.667-1.06 5.567-3.18 8.7-2.12 3.133-5.327 6.527-9.62 10.18Z"
    />
  </svg>
);

export const Jobs = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}
    viewBox="0 0 45 45">
    <path
      d="M11.7 35.2v-4.7H8.5v-3h3.2v-4.3h-5L22.6 9l15.8 14.2h-5v4.3h3.2v3h-3.2v4.7h-3v-4.7H24v4.7h-3v-4.7h-6.3v4.7h-3Zm3-7.7H21V14.4L14.7 20v7.5Zm9.3 0h6.3V20L24 14.4v13Z"
      fill="currentColor"
    />
  </svg>
);

export const Users = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}
    viewBox="0 0 45 45">
    <path
      d="M6.8 35v-3.9c0-1 .2-1.8.6-2.5.5-.8 1.2-1.3 2-1.7 1.7-.8 3.2-1.3 4.6-1.7a17.6 17.6 0 0 1 8.6 0c1.4.3 3 .9 4.6 1.7.9.3 1.5 1 2 1.7s.7 1.6.7 2.5v4H6.8Zm25.4 0v-3.8c0-1.6-.4-2.9-1.1-3.9-.7-1-1.7-1.9-3-2.6a34 34 0 0 1 7.5 2 5 5 0 0 1 2.6 4.5V35h-6ZM18.3 22.5c-1.6 0-2.9-.5-3.9-1.6-1-1-1.5-2.4-1.5-4 0-1.7.5-3 1.5-4 1-1.1 2.3-1.7 4-1.7 1.5 0 2.8.6 3.8 1.6s1.6 2.4 1.6 4c0 1.7-.5 3-1.6 4.1-1 1-2.3 1.6-3.9 1.6Zm13.2-5.6c0 1.6-.5 3-1.5 4s-2.3 1.6-4 1.6a6 6 0 0 1-1.7-.3 6 6 0 0 0 1.3-2.3 9.3 9.3 0 0 0 0-6c-.3-.9-.7-1.7-1.3-2.4a7 7 0 0 1 1.8-.3c1.6 0 2.9.6 3.9 1.6s1.5 2.4 1.5 4Zm-22 15.3H27v-1a2 2 0 0 0-.3-1c-.2-.4-.5-.7-.8-.8-1.6-.8-3-1.2-4-1.5a16.3 16.3 0 0 0-7.3 0c-1.1.3-2.5.7-4.1 1.5-.3.1-.6.4-.8.7a2 2 0 0 0-.3 1v1Zm8.8-12.3c.9 0 1.6-.3 2.1-.9a3 3 0 0 0 .8-2.1 3 3 0 0 0-.8-2.2c-.5-.6-1.2-.8-2-.8-1 0-1.6.2-2.2.8a3 3 0 0 0-.8 2.2c0 .8.3 1.6.8 2.1.6.6 1.3.9 2.1.9Z"
      fill="currentColor"
    />
  </svg>
);

export const Builders = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}
    viewBox="0 0 45 45">
    <path
      d="M5.6 38.3v-21L19.4 6.7l10.4 8a7.4 7.4 0 0 0-4 1L19.3 11 8.9 19v16h7.8a4 4 0 0 0 0 .6v2.8h-11Zm13.5 0v-3.5a3.6 3.6 0 0 1 1.7-3.1 17.3 17.3 0 0 1 8.4-2.4 16 16 0 0 1 8.5 2.4c.5.3 1 .7 1.2 1.3.3.6.5 1.2.5 1.8v3.5H19Zm3.3-3h13.7v-1.2c-1.1-.6-2.2-1-3.4-1.3a12.3 12.3 0 0 0-7 0c-1 .3-2.2.8-3.3 1.4v1.1Zm6.9-7.4a5 5 0 0 1-3.7-1.6c-1-1-1.5-2.2-1.5-3.7s.5-2.7 1.5-3.8a5 5 0 0 1 3.6-1.5 5 5 0 0 1 3.7 1.5c1 1 1.5 2.3 1.5 3.8 0 1.4-.5 2.7-1.5 3.7a5 5 0 0 1-3.6 1.6Zm0-3c.6 0 1.2-.2 1.6-.6.5-.5.7-1 .7-1.7a2.3 2.3 0 0 0-2.4-2.4c-.6 0-1.2.2-1.6.7-.5.4-.7 1-.7 1.7a2.3 2.3 0 0 0 2.3 2.4Z"
      fill="currentColor"
    />
  </svg>
);

export const Companies = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}>
    <path
      fill="currentColor"
      d="M10 33V7h20v26h-8.571v-5.778H18.57V33H10Zm2.857-2.889h2.857v-5.778h8.572v5.778h2.857V9.89H12.857V30.11Zm2.857-8.667h2.857v-2.888h-2.857v2.888Zm0-5.777h2.857v-2.89h-2.857v2.89Zm5.715 5.777h2.857v-2.888h-2.857v2.888Zm0-5.777h2.857v-2.89h-2.857v2.89Z"
    />
  </svg>
);

export const Inventory = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}>
    <path
      fill="currentColor"
      d="M15.704 31.111c-1.413 0-2.622-.503-3.628-1.509-1.005-1.005-1.508-2.214-1.508-3.627V15.48a3.967 3.967 0 0 1-1.846-1.396A3.661 3.661 0 0 1 8 11.852c0-1.07.374-1.98 1.123-2.729C9.873 8.374 10.782 8 11.852 8s1.98.374 2.728 1.123c.75.75 1.124 1.659 1.124 2.729 0 .834-.241 1.578-.723 2.23a3.967 3.967 0 0 1-1.845 1.397v10.496c0 .706.251 1.311.754 1.814a2.473 2.473 0 0 0 1.814.754c.706 0 1.31-.251 1.813-.754a2.473 2.473 0 0 0 .755-1.814v-12.84c0-1.412.503-2.62 1.508-3.626C20.786 8.503 21.995 8 23.407 8c1.413 0 2.622.503 3.628 1.509 1.005 1.005 1.508 2.214 1.508 3.627v10.496a3.967 3.967 0 0 1 1.846 1.396c.481.653.722 1.397.722 2.231 0 1.07-.374 1.98-1.123 2.729-.75.749-1.659 1.123-2.729 1.123s-1.98-.374-2.728-1.123c-.75-.75-1.124-1.659-1.124-2.729 0-.834.241-1.583.723-2.247a3.736 3.736 0 0 1 1.845-1.38V13.136c0-.706-.251-1.31-.754-1.814a2.473 2.473 0 0 0-1.814-.754c-.706 0-1.31.251-1.813.754a2.473 2.473 0 0 0-.755 1.814v12.84c0 1.412-.502 2.62-1.508 3.627-1.006 1.005-2.215 1.508-3.627 1.508Zm-3.852-17.975c.364 0 .669-.123.915-.37.246-.245.369-.55.369-.914s-.123-.669-.37-.915a1.242 1.242 0 0 0-.914-.37c-.364 0-.669.124-.915.37s-.37.551-.37.915.124.669.37.915.551.369.915.369Zm15.407 15.407c.364 0 .669-.123.915-.369s.37-.551.37-.915-.124-.669-.37-.915a1.243 1.243 0 0 0-.915-.369c-.364 0-.669.123-.915.37-.246.245-.369.55-.369.914s.123.669.37.915c.245.246.55.37.914.37Z"
    />
  </svg>
);

export const Tenants = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}
    viewBox="0 0 46 48">
    <path
      fill="currentColor"
      d="M9.364 37.5c-1.42 0-2.628-.486-3.623-1.458-.994-.973-1.491-2.153-1.491-3.542 0-1.389.497-2.57 1.491-3.542.995-.972 2.202-1.458 3.623-1.458.255 0 .504.02.745.063.242.041.476.09.704.145l6.903-9.291a6.757 6.757 0 0 1-1.13-1.959 6.494 6.494 0 0 1-.404-2.291c0-1.834.667-3.403 2.003-4.709C19.52 8.153 21.125 7.5 23 7.5c1.875 0 3.48.653 4.815 1.958 1.336 1.306 2.003 2.875 2.003 4.709 0 .805-.142 1.57-.426 2.291a7.155 7.155 0 0 1-1.15 1.959l6.945 9.291c.228-.055.462-.104.704-.145.241-.042.49-.063.745-.063 1.42 0 2.628.486 3.622 1.458.995.973 1.492 2.153 1.492 3.542 0 1.389-.497 2.57-1.492 3.542-.994.972-2.201 1.458-3.622 1.458-1.42 0-2.628-.486-3.622-1.458-.994-.973-1.491-2.153-1.491-3.542 0-.528.078-1.035.234-1.52.156-.487.376-.924.66-1.313l-6.903-9.292a2.674 2.674 0 0 1-.405.125c-.128.028-.262.07-.405.125v7.167a4.95 4.95 0 0 1 2.45 1.791 4.77 4.77 0 0 1 .96 2.917c0 1.389-.498 2.57-1.492 3.542S24.421 37.5 23 37.5c-1.42 0-2.628-.486-3.622-1.458-.994-.973-1.492-2.153-1.492-3.542 0-1.083.32-2.049.96-2.896a5.255 5.255 0 0 1 2.45-1.812v-7.167a2.675 2.675 0 0 0-.405-.125 2.674 2.674 0 0 1-.405-.125l-6.904 9.292c.284.389.505.826.66 1.312.157.486.235.993.235 1.521 0 1.389-.497 2.57-1.491 3.542-.995.972-2.202 1.458-3.622 1.458Zm0-3.333c.483 0 .887-.16 1.214-.48.327-.319.49-.715.49-1.187 0-.472-.163-.868-.49-1.188-.327-.319-.731-.479-1.214-.479s-.888.16-1.215.48c-.327.319-.49.715-.49 1.187 0 .472.163.868.49 1.188.327.319.732.479 1.215.479Zm13.636 0c.483 0 .888-.16 1.215-.48.326-.319.49-.715.49-1.187 0-.472-.164-.868-.49-1.188-.327-.319-.732-.479-1.215-.479-.483 0-.888.16-1.215.48-.326.319-.49.715-.49 1.187 0 .472.164.868.49 1.188.327.319.732.479 1.215.479Zm13.636 0c.483 0 .888-.16 1.215-.48.327-.319.49-.715.49-1.187 0-.472-.163-.868-.49-1.188-.327-.319-.732-.479-1.215-.479-.483 0-.887.16-1.214.48-.327.319-.49.715-.49 1.187 0 .472.163.868.49 1.188.327.319.731.479 1.214.479ZM23 17.5a3.32 3.32 0 0 0 2.408-.98c.667-.652 1.001-1.437 1.001-2.353 0-.917-.334-1.702-1.001-2.354a3.32 3.32 0 0 0-2.408-.98 3.32 3.32 0 0 0-2.408.98c-.667.652-1.001 1.437-1.001 2.354 0 .916.334 1.701 1.001 2.354A3.32 3.32 0 0 0 23 17.5Z"
    />
  </svg>
);

export const Admins = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={NAV_ICON_SIZE}
    width={NAV_ICON_SIZE}
    viewBox="0 0 46 45">
    <path
      fill="currentColor"
      d="M30.031 27.422c-1.115 0-2.058-.397-2.829-1.19-.77-.793-1.155-1.763-1.155-2.912 0-1.148.385-2.119 1.155-2.912.77-.793 1.714-1.19 2.83-1.19 1.115 0 2.058.397 2.828 1.19.77.793 1.156 1.764 1.156 2.912 0 1.149-.386 2.12-1.156 2.912-.77.793-1.713 1.19-2.829 1.19Zm-7.968 8.203v-2.297c0-.656.166-1.265.498-1.825.332-.56.803-.964 1.414-1.21a14.98 14.98 0 0 1 2.968-.923 15.664 15.664 0 0 1 6.176 0 14.98 14.98 0 0 1 2.968.923c.611.246 1.083.65 1.415 1.21.332.56.498 1.169.498 1.825v2.297H22.062ZM18.875 22.5c-1.753 0-3.254-.643-4.502-1.928-1.249-1.285-1.873-2.83-1.873-4.634 0-1.805.624-3.35 1.873-4.635 1.248-1.285 2.749-1.928 4.502-1.928 1.753 0 3.254.643 4.502 1.928 1.249 1.285 1.873 2.83 1.873 4.634 0 1.805-.624 3.35-1.873 4.635-1.248 1.285-2.749 1.928-4.502 1.928ZM6.125 35.625v-4.594c0-.93.226-1.784.677-2.563a4.507 4.507 0 0 1 1.873-1.784 23.53 23.53 0 0 1 4.96-1.887 21.094 21.094 0 0 1 5.24-.656c.93 0 1.86.082 2.79.246.929.164 1.858.355 2.788.574l-1.355 1.395-1.354 1.394a7.557 7.557 0 0 0-1.435-.267 17.92 17.92 0 0 0-5.957.513c-1.473.383-2.888.93-4.243 1.64a1.371 1.371 0 0 0-.597.575 1.7 1.7 0 0 0-.2.82v1.313h9.563v3.281H6.125Zm12.75-16.406c.877 0 1.627-.322 2.251-.964a3.207 3.207 0 0 0 .936-2.317c0-.903-.312-1.675-.936-2.318-.624-.643-1.374-.964-2.251-.964-.877 0-1.627.321-2.251.964a3.207 3.207 0 0 0-.936 2.318c0 .902.312 1.674.936 2.317.624.643 1.374.964 2.251.964Z"
    />
  </svg>
);

export const icons: Record<Tab, ReactNode> = {
  hotSeat: <HotSeat />,
  workload: <Workload />,
  onDeck: <OnDeck />,
  map: <Map />,
  jobs: <Jobs />,
  users: <Users />,
  builders: <Builders />,
  companies: <Companies />,
  inventory: <Inventory />,
  tenants: <Tenants />,
  admins: <Admins />,
};
